export const IDECON_WEBSITE_URL = 'https://www.idecon.com.tr/';
export const REDIRECT_DELAY_SECONDS = 5;

export const redirectToIdeconWebsite = () => window.location.replace(IDECON_WEBSITE_URL);

export const RATING_VALUES = [1, 2, 3, 4, 5] as const;

export type RatingValue = (typeof RATING_VALUES)[number];
export type RatingLabels = Record<RatingValue, string>;
